import styled from 'styled-components';

import { ArrivedLogoImage } from '@arrived/images';

const StyledArrivedFooterLogo = styled.div`
  &.arrived-footer-logo-wrapper {
    height: 40px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    .arrived-footer-logo {
      width: auto;
      height: 30px;
    }
  }
`;

export const ArrivedFooterLogo = () => {
  return (
    <StyledArrivedFooterLogo className="arrived-footer-logo-wrapper">
      <ArrivedLogoImage className="arrived-footer-logo" />
    </StyledArrivedFooterLogo>
  );
};
